import type { SiteConfig } from '@/types'

export const siteConfig: SiteConfig = {
    name: 'Stream Showcase',
    description:
        'A streaming-style library of curated video playlists that help founders, indie hackers, and makers level up.',
    url: 'https://streamshowcase.com'
}
